import { Alert } from '@ps/sports-ui-component-library';
import React, { useEffect } from 'react';
import { useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import TranslationWithLink from '@swf/sports/components/TranslationWithLink/TranslationWithLink';
import { BET_SLIP_AUTO_DISMISS_DELAY } from '@swf/sports/utils/constants';

import useDismissibleBetSlipError from '../../../../hooks/useDismissibleBetSlipError';
import Message from '../Message/Message';

const Error: React.FC = () => {
  const {
    titleTranslationTag,
    contentTranslationTag,
    isAutoDismissible,
    dismissError,
    alias,
    resolverTag
  } = useDismissibleBetSlipError();
  const { submitErrors, values } = useFormState();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!contentTranslationTag || !submitErrors) {
      return;
    }

    const hasExistingError = Object.keys(values).some((valueKey) => submitErrors[valueKey]);
    if (!hasExistingError) {
      dismissError();
    }
  }, [dismissError, contentTranslationTag, submitErrors, values]);

  useEffect(() => {
    if (contentTranslationTag && isAutoDismissible) {
      const timeout = setTimeout(dismissError, BET_SLIP_AUTO_DISMISS_DELAY);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [contentTranslationTag, isAutoDismissible, dismissError]);

  if (!contentTranslationTag) {
    return null;
  }

  const isCollapsible = !!titleTranslationTag;
  if (isCollapsible) {
    return (
      <Alert
        isCollapsible
        title={formatMessage(titleTranslationTag)}
        level="destructive"
        variant="aggressive"
        isSquare
      >
        <TranslationWithLink
          contentTranslationTag={contentTranslationTag}
          alias={alias}
          resolverTag={resolverTag}
        />
      </Alert>
    );
  }

  return (
    <Message
      type="ERROR"
      isAutoDismissible={isAutoDismissible}
      message={
        <TranslationWithLink
          contentTranslationTag={contentTranslationTag}
          alias={alias}
          resolverTag={resolverTag}
        />
      }
      dismissCallback={dismissError}
    />
  );
};

export default Error;
